export enum CustomizeLater{
    CUSTOMIZE_LATER_INTERACTION = "customize_later_interaction",
    PERFECT_PRINT_PROMISE_POPUP = "perfect-print-promise-popup",
    CONTACT_US = "contact-us",
}